import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import './SubscriptionInput.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretRight, faCaretDown } from '@fortawesome/free-solid-svg-icons';
import WheatherTimeSelect from './WheatherTimeSelect';

class SubscriptionInput extends React.Component {
  constructor(props) {
    super(props);
    // const checked = props.checked;
    const subChildren = _.reduce(
      _.get(props, 'subscription.nodes', []),
      (acc, node) => {
        const id = node.serviceId;
        acc[id] = node.checked;
        return acc;
      },
      {},
    );
    const childrenDisabledObj = _.reduce(
      _.get(props, 'subscription.nodes', []),
      (acc, node) => {
        const disabledId = `${node.serviceId}_disabled`;
        acc[disabledId] = node.disabled;
        return acc;
      },
      {},
    );
    const { subscription, selfIndex } = this.props;
    const { checked: subChecked, disabled } = subscription;

    this.state = {
      checked: subChecked,
      collapsed: true,
      subChildren,
      toggleParent: false,
      disabled,
      childrenDisabledObj,
      collapseTouched: false
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.updateStateSync = this.updateStateSync.bind(this);
    this.handleInputChangeForParent = this.handleInputChangeForParent.bind(this);
    this.handleCollapseIconClick = this.handleCollapseIconClick.bind(this);
    this.collectIndex = this.collectIndex.bind(this)
    this.addThisLevel = this.addThisLevel.bind(this)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { checked, subscription, setAlertData } = this.props;
    const { subChildren, toggleParent, disabled, childrenDisabledObj } = this.state;
    const diffChecked = checked !== nextProps.checked;
    if (diffChecked) {
      const hasOneChild = _.size(subscription.node) === 1;
      let newChildren = subChildren;
      if (!toggleParent || hasOneChild || !nextProps.synToggleParentFlag) {
        newChildren = _.mapValues(subChildren, (value, key, object) => {
          const disabledKey = `${key}_disabled`;
          if (childrenDisabledObj[disabledKey]) {
            return childrenDisabledObj[disabledKey];
          }
          return nextProps.checked;
        });
      }
      setAlertData(newChildren);
      this.setState({
        checked: disabled || nextProps.checked,
        subChildren: newChildren,
      });
    }
    // if (collapsed) {
    //   this.handleCollapseIconClick();
    // }
  }

  updateStateSync(stateUpdate) {
    return new Promise(resolve => {
      this.setState(stateUpdate, () => resolve())
    })
  }

  async handleInputChange(event) {
    const { handleInputChangeForParent, subscription, setAlertData, selfIndex } = this.props;
    const { subChildren, collapsed, childrenDisabledObj, collapseTouched } = this.state;
    const { checked } = event.target;

    if (!collapseTouched) {
      await this.updateStateSync({ collapseTouched: true })
    }

    const newChildren = _.mapValues(subChildren, (value, key, object) => {
      const disabledKey = `${key}_disabled`;
      if (childrenDisabledObj[disabledKey]) {
        return childrenDisabledObj[disabledKey];
      }
      return checked;
    });
    this.addThisLevel(checked)

    this.setState(
      {
        checked,
        subChildren: newChildren, // handle child nodes
        toggleParent: false,
      },
      () => handleInputChangeForParent(checked, subscription),
    );
    this.synToggleParentFlag = false;
    setAlertData(newChildren);
    if (collapsed) {
      this.handleCollapseIconClick();
    }
  }

  handleInputChangeForParent(checked, childSubscription) {
    const { subscription, handleInputChangeForParent, setAlertData } = this.props;
    const { subChildren } = this.state;
    if (!subscription.leaf) {
      const newChildren = { ...subChildren, [childSubscription.serviceId]: checked };
      // check to see if the children are checked
      const parentChecked =
        _.chain(newChildren)
          .values()
          .compact()
          .size()
          .value() === _.size(subscription.nodes);
      setAlertData(newChildren);
      this.setState(
        {
          checked: parentChecked,
          subChildren: newChildren,
          toggleParent: true,
        },
        () => handleInputChangeForParent(parentChecked, subscription),
      );
      this.synToggleParentFlag = true;
    }
  }

  addThisLevel(checked) {
    const { selfIndex, passToPrevLevel } = this.props;

    // pass index of this level to parent level
    passToPrevLevel([selfIndex], checked)
  }

  collectIndex(indexes, checked) {
    // collect the index of every level recursively then pass to parent level
    const { subscription, selfIndex, levelNodeCount, passToPrevLevel } = this.props;
    passToPrevLevel([...indexes, selfIndex], checked)
  }

  handleCollapseIconClick() {
    const { collapsed, collapseTouched } = this.state;
    this.setState({
      collapseTouched: true,
      collapsed: !collapsed,
    });
  }

  render() {
    const { subscription, isRootElement, setAlertData,
      handleConfirmWindowShow,
      startTime,
      startMeridiem,
      endTime,
      endMeridiem,
      timeZoneId,
      handleWheatherTimeChange,
      wheatherChecked,
      showAlertSubscriptionTimeZone,
      parentTouched
    } = this.props;
    const { checked, collapsed, subChildren, disabled, collapseTouched } = this.state;

    const icon = collapsed ? 'fa-caret-right' : 'fa-caret-down';
    const iconClassName = collapsed
      ? 'SubscriptionInput__icon--plus'
      : 'SubscriptionInput__icon--minus';
    const displayCollapseIcon = !_.isNull(_.get(subscription, 'nodes', null));
    const childrenCount = _.size(subscription.nodes);
    const hasChildren = childrenCount > 0;
    const displayChildrenCount = !isRootElement && hasChildren;
    const nameClass = hasChildren ? 'SubscriptionInput__name' : '';
    const oneFlag = subscription.level === 'one';
    const isWheather = subscription.type === 'Weather';
    return (
      <div>
        <div className={` ${oneFlag && 'title'} ${!hasChildren && 'title-no-underline'}`}>
          {
            hasChildren &&
          <button
            type="button"
            onClick={() => this.handleCollapseIconClick()}
            aria-expanded={!collapsed}
            aria-label={subscription.name}
          >
            {displayCollapseIcon && (
              <FontAwesomeIcon
                icon={collapsed ? faCaretRight : faCaretDown}
                width="1.275em"
                height="1.275em"
              />
            )}
          </button>
          }
          <input
            type="checkbox"
            checked={checked}
            onChange={this.handleInputChange}
            disabled={disabled}
            aria-label={subscription.name}
          />
          <span
            className={nameClass, isWheather ? '' : 'notranslate'}
            id={`${subscription.serviceId}Label`}
          >
            {subscription.name}
            {displayChildrenCount && (
              <span className={`${nameClass} SubscriptionInput__children--count`}>
                ({childrenCount})&lrm;
              </span>
            )}
          </span>
        </div>

        <div className={` ${oneFlag && isWheather && 'row'} col-md-12 m-0 p-0 justify-content-between alert-sub-align`}>
          {
            ((parentTouched != null) || (collapseTouched)) &&
              <ul
                className={` ${oneFlag && isWheather && 'false'}`, isWheather ? '' : 'notranslate'}
                style={{ display: collapsed ? 'none' : 'block' }}
              >
                {_.map(subscription.nodes, (subscriptionChildNode, index) => (
                  <li key={index}>
                    <SubscriptionInput
                      selfIndex={index}
                      passToPrevLevel={(indexes, checked) => this.collectIndex(indexes, checked)}
                      subscription={subscriptionChildNode}
                      checked={subChildren[subscriptionChildNode.serviceId]}
                      handleInputChangeForParent={this.handleInputChangeForParent}
                      setAlertData={setAlertData}
                      parentChecked={checked}
                      synToggleParentFlag={this.synToggleParentFlag}
                      wheatherChecked={wheatherChecked}
                      handleConfirmWindowShow={handleConfirmWindowShow}
                      startTime={startTime}
                      startMeridiem={startMeridiem}
                      endTime={endTime}
                      endMeridiem={endMeridiem}
                      timeZoneId={timeZoneId}
                      handleWheatherTimeChange={handleWheatherTimeChange}
                      showAlertSubscriptionTimeZone={showAlertSubscriptionTimeZone}
                      parentTouched={collapseTouched}
                    />
                  </li>
                ))
                }
              </ul>
          }
          {
            showAlertSubscriptionTimeZone && oneFlag && isWheather && !collapsed &&
            <WheatherTimeSelect
              wheatherChecked={wheatherChecked}
              handleConfirmWindowShow={handleConfirmWindowShow}
              startTime={startTime}
              startMeridiem={startMeridiem}
              endTime={endTime}
              endMeridiem={endMeridiem}
              timeZoneId={timeZoneId}
              handleWheatherTimeChange={handleWheatherTimeChange}
            />
          }
        </div>

      </div>
    );
  }
}

SubscriptionInput.propTypes = {
  isRootElement: PropTypes.bool,
  defaultCollapsed: PropTypes.bool,
  checked: PropTypes.bool,
  subscription: PropTypes.shape(),
  handleInputChangeForParent: PropTypes.func,
  setAlertData: PropTypes.func.isRequired,
  parentChecked: PropTypes.bool,
  wheatherChecked: PropTypes.bool.isRequired,
  handleConfirmWindowShow: PropTypes.func.isRequired,
  startTime: PropTypes.string.isRequired,
  startMeridiem: PropTypes.string.isRequired,
  endTime: PropTypes.string.isRequired,
  endMeridiem: PropTypes.string.isRequired,
  timeZoneId: PropTypes.string.isRequired,
  handleWheatherTimeChange: PropTypes.func.isRequired,
  showAlertSubscriptionTimeZone: PropTypes.bool.isRequired,
};

SubscriptionInput.defaultProps = {
  isRootElement: false,
  parentChecked: false,
  defaultCollapsed: true,
  checked: false,
  subscription: {},
  handleInputChangeForParent: () => { },
};

export default SubscriptionInput;
